var map = {
	"./0.png": 575013,
	"./1.png": 147006,
	"./2.png": 85541,
	"./3.png": 827284,
	"./4.png": 37875,
	"./5.png": 249136,
	"./6.png": 580479,
	"./7.png": 240785,
	"./8.png": 599044,
	"./9.png": 164365
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 110298;